import { nanoid } from '@reduxjs/toolkit';

/**
 *
 * @param {number} position
 * @param {number} length
 * @return {EmojiHistoryChunk}
 */
export function createChunk(position, length) {
	const chunk = {
		timestamp: Date.now(),
		...getBounds(position, length),
		id: nanoid(),
		results: [],
	};

	if (process.env.NODE_ENV === 'development') {
		function readable(number) {
			if (number > 31449600) {
				return new Date(number * 1e3).toLocaleTimeString();
			}
			return number;
		}

		Object.defineProperties(chunk, {
			_from: {
				value: readable(chunk.from),
			},
			_to: {
				value: readable(chunk.to),
			},
		});
	}

	return chunk;
}

function getBounds(position, length) {
	const from = position - (position % length);
	const to = from + length - 1;

	return {
		from,
		to,
	};
}
